import React, { useContext, useState, useEffect, useRef, useMemo } from "react";
import { FaEllipsisH } from "react-icons/fa";
import { IoEllipse } from "react-icons/io5";
import UserTagIconSVG from "assets/svg/user-tag-icon";
import { Context } from "context/context";
import { formatDate,currentLang, toTitleCase } from "utils/utils";
import ViewMilestoneDialog from "./view-dialog";
import Popup from "reactjs-popup";
import OptionListItem from "./more-option/option-list-item";
import _ from "lodash";
import LazyImage from "./LazyImage";
import { removePostalCode } from "utils/utils";
import { useDialogHook } from "utils/customhooks";
import { useMilestones } from "redux/modules/milestone/hooks";
import PrivacyBadge from "components/milestonelist/privacyBadge";
import { AiFillPushpin } from "react-icons/ai";
import {
  DATE_NEWEST_TO_OLDEST,
  DATE_OLDEST_TO_NEWEST,
} from "constants/options";
import { CoverPlaceholderMilestone } from "constants/images";
import { useTranslation } from "react-i18next";
import Collapsible from "components/collapsible";
import { CgArrowsExchangeV } from "react-icons/cg";
import PinnedReorder from "./pinned-reorder";
import Button from "components/button/button";
import { scrollToElementWithOffset } from "./detailed-view";
import { useLocation, useHistory } from 'react-router-dom';
import { BsExclamationDiamondFill } from "react-icons/bs";

const ListViewCard = ({
  title,
  dateNote,
  date,
  privacy,
  profile,
  featured,
  people,
  positions = [],
  platform,
  location,
  url = "",
  viewUrl = "",
  category,
  isAdultContent,
  isYourProfile,
  onView = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onShare = () => {},
  share,
  closeModal = () => {},
  onReport = () => {},
  dateMobile = null,
  mention_names={},
  categories=[],
  dataId,
  translateMilestone=()=>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  onAnalytics = () => {},
  tagView = false,
  onRemoveTag = () => {},
}) => {
  const { showMaturedContent, setShowMaturedContent } = useContext(Context);
  const [showMoreOption, setShowMoreOption] = useState();
  // const [customClass, setCustomClass] = useState("");
  const optionRef = useRef();
  const { translation = {} } = featured;
  const {t} = useTranslation()

  // useEffect(() => {
  //   (async () => {
  //     const res = await imageSquareOrPortrait(url);
  //     if (res === "portrait") {
  //       setCustomClass(
  //         "h-23 w-23 2sm:h-29.5 2sm:w-29.5 3md:w-50 3md:h-50 bg-contain"
  //       );
  //     } else if (res === "landscape") {
  //       setCustomClass(
  //         "h-23 w-23 2sm:h-29.5 2sm:w-29.5 3md:w-50 3md:h-50 bg-contain"
  //       );
  //     } else {
  //       setCustomClass(
  //         "h-23 w-23 2sm:h-29.5 2sm:w-29.5 3md:w-50 3md:h-50 bg-cover"
  //       );
  //     }
  //   })();
  // }, [url]);

  useEffect(() => {
    window.addEventListener(
      "scroll",
      () => {
        if (optionRef.current) {
          optionRef.current.close();
        }
      },
      true
    );
  }, []);

  const loc = useLocation();
  const history = useHistory();


  useEffect(() => {
    const search = new URLSearchParams(loc.search);
    const focusMiletone = search.get("focusMilestone");
    if(focusMiletone) {
      const targetId = Number(focusMiletone);
      const currentId = Number(dataId);
      if(targetId === currentId) {
        const element = document.querySelector(`[data-milestone-id="${targetId}"]`);
        // element.scrollIntoView();
        scrollToElementWithOffset(element, 120); // scroll with 50px top space
        const pathWithoutSearch = loc.pathname;
        history.replace(pathWithoutSearch);
      }
    }
  }, [loc, dataId, history]);

  return (
    <div
      className="w-full bg-siteBg rounded-md mt-3 2sm:mt-4.5 3md:mt-6 cursor-pointer overflow-hidden"
      onClick={onView}
      data-milestone-id={dataId || "no-id"}
    >
      <div className="w-full flex space-x-0.5">
        {/* image */}
        {url ? (
          <div className="relative bg-white h-auto w-23 2sm:h-auto 2sm:w-29.5 3md:w-50 3md:h-50 overflow-hidden">
            {/* thumbnail */}
            <LazyImage
              source={url}
              viewUrl={viewUrl}
              customClassName="w-full"
              secondView={true}
            />
            {/* restricted Image */}
            {/* {!isAdultContent && !showMaturedContent && (
              <div className="absolute top-0 left-0 matured-content-blured">
                <button
                  className="w-full flex justify-center"
                  onClick={() => setShowMaturedContent((prev) => !prev)}>
                  <BsExclamationDiamondFill className="text-base 1sm:text-5xl cursor-pointer" />
                </button>
              </div>
            )} */}
          </div>
        ) : (
          <div className="relative h-auto w-23 2sm:h-auto 2sm:w-29.5 3md:w-50 3md:h-50 flex itmes-center justify-center bg-[#e9e9e9]">
            <div className="relative flex items-center justify-center h-full w-23 2sm:h-auto 2sm:w-29.5 3md:w-50 3md:h-50 bg-[#e9e9e9]">
              <img
                src={CoverPlaceholderMilestone}
                alt="Milestone"
                className="w-[43px] h-[41px] 3md:h-[81px]  3md:w-[83px] "
              />
            </div>
          </div>
        )}
        {/* content container */}
        <div
          className={`relative bg-white 2md:mt-0 px-4.5 py-3 3md:px-9 3md:py-6 ${
            url
              ? "width-responsive-list-view"
              : "width-responsive-list-view-full"
          }`}
        >
          {/* content */}
          <div className="w-full flex justify-between 2sm:items-start gap-6">
            <div className="w-full">
              {/* title */}
              <div className="flex items-center space-x-1 ">
                {/* <p className="whitespace-nowrap text-base 2sm:text-2xl 3md:text-2.5xl text-lightBlack font-medium tracking-tighter">
                  {title}
                </p> */}
                <div className="max-w-full max-h-12 overflow-hidden">
                  <h1 className="text-[14px] leading-tight line-clamp-2 2sm:text-2xl 3md:text-2.5xl">
                    {toTitleCase(translation?.[currentLang()]?.[title] || title)}
                  </h1>
                </div>
              </div>
              {/* category */}
              {/* <div className="items-center space-x-5 flex-wrap hidden 3md:flex">
                <p className="px-1.5 py-1 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md">
                  {category}
                </p>
              </div> */}
              {/* details */}
              <div className="w-full mt-0 2sm:mt-1.5">
                {/* <div className="w-full whitespace-nowrap text-4xs 2sm:text-sm 3md:text-base text-darkerGray font-medium
                 3md:leading-6 flex items-center space-x-2 3md:space-x-3 flex-wrap"> */}

                {/* Hide when in mobile view */}
                {/* <div
                  className="w-full text-4xs 2sm:text-sm 3md:text-base text-darkerGray font-medium 
                      3md:leading-[16px] flex items-center space-x-2 3md:space-x-3 hidden 2sm:flex flex-wrap"
                > */}
                <div
                  className="w-full text-4xs 2sm:text-sm 3md:text-base text-darkerGray font-medium 
                      3md:leading-[16px] flex items-center hidden 2sm:flex flex-wrap gap-x-2 gap-y-1"
                >
                  <div className="item-col">
                    <p className="relative  whitespace-nowrap">
                      {date}
                      {dateNote && (
                        <span className="ml-1">{`(${translation?.[currentLang()]?.[dateNote] || dateNote})`}</span>
                      )}
                    </p>
                  </div>
                  {
                    isYourProfile &&
                    <div className="item-col">
                      <PrivacyBadge
                        privacy={privacy}
                        isYourProfile={isYourProfile}
                      />
                    </div>
                  }


                  {isAdultContent && (
                    <div className="item-col">                      
                      <span className="text-red flex flex-row items-center font-medium  whitespace-nowrap text-4xs 2sm:text-sm 3md:text-base">
                        <BsExclamationDiamondFill className="mr-1.5 " /> {t('adultContent')}
                      </span>
                    </div>
                  )}

                  
                  {/* <p className="flex items-center capitalize">
                    {privacy === "public" ? (
                      <BsGlobe2 className="mr-1.5" />
                    ) : (
                      <BsExclamationDiamondFill className="mr-1.5" />
                    )}
                    {privacy}
                  </p> */}
                  {people && (
                    <div className="item-col">
                      {/* <p className="hidden md:block">
                        <IoEllipse className="w-1 h-1" />
                      </p> */}
                      <p className="hidden md:flex items-center">
                        <UserTagIconSVG className="mr-1.5" />
                        {people}
                      </p>
                    </div>
                  )}
                  {/* <div className="item-col">
                    <p 
                      className="inline-flex px-1.5 py-1 hidden 2sm:inline-flex 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md items-center justify-center"
                      style={{ 
                        ...(isAdultContent && {
                          marginLeft: 0
                        })
                      }}
                    >
                      {category}
                    </p>
                  </div> */}
                  <div className="hidden 2sm:inline-flex flex-wrap gap-2">
                      {
                        categories.map((item,index)=>{
                          return(
                              <p key={index} 
                              style={{ 
                                ...(isAdultContent && {
                                  marginLeft: 0
                                })
                              }}
                              className="px-1.5 py-1 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md items-center justify-center">
                                {(!profile?.dateFormat && item[currentLang()] === 'Theatre') ? 'Theater' : item[currentLang()] ||item.name}
                              </p>
                          )
                        })
                      }
                    </div> 
                </div>
              </div>
              {/* Author Name and description */}
              {/* Hide when in mobile view */}
              <div className="w-full mt-4 3md:mt-4 hidden 2sm:inline">
                <p className="text-4xs 2sm:text-sm 3md:text-base font-bold 3md:leading-6 mt-1.5 break-anywhere">
                  {/* {positions.map((p, i) => (
                    <span key={i}>
                      {p.position.name}
                      {p.description && ` - ${removePostalCode(p.description)}`}
                      {i < positions.length - 1 && ", "}
                    </span>
                  ))} */}
                  <span>
                    {positions
                      .map((p) => {
                        const _pos = [p.position[currentLang()]?.trim() || p.position.name?.trim()];
                        if (p.description)
                          _pos.push(removePostalCode(p.description).trim());
                        return _pos.join(" - ");
                      })
                      .join(", ")
                      .trim()}
                  </span>
                  <span className="pl-[0.15rem]">
                    {platform && (
                      <>
                        (
                        {translation?.[currentLang()]?.[platform] || platform}
                        {(location && location !== 'null') && ` - ${translation?.[currentLang()]?.[location] || location}`}
                        )
                      </>
                    )}
                  </span>
                </p>
              </div>
              {/* Show when in mobile view */}
              <div className="w-full mt-4 3md:mt-4 inline 2sm:hidden">
                <p className="text-4xs 2sm:text-sm 3md:text-base font-bold 3md:leading-6 break-anywhere mt-1">
                  {positions.length > 0 && (
                    <>
                      <span>
                        {/* {positions[0]?.position.name}
                        {positions[0]?.description &&
                          ` - ${positions[0]?.description} `} */}

                          {positions?.map?.(pos => {

                            return [pos.position?.name, pos.description].filter(p => !!p).join(" - ");
                          }).join(", ")}
                      </span>
                      <span className="pl-[0.15rem]">
                        {platform && (
                          <>
                            (
                            {translation?.[currentLang()]?.[platform] || platform}
                            {(location && location !== 'null') && ` - ${translation?.[currentLang()]?.[location] || location}`}
                            )
                          </>
                        )}
                      </span>
                      {/* {positions.length > 1 && <span>...</span>} */}
                    </>
                  )}
                </p>
                <p className="relative w-full break-words text-1xs 2sm:text-sm 3md:text-base text-darkerGray font-medium inline-flex gap-[2px] items-center mt-1.5">
                  <>
                    {dateMobile && (
                      <>
                        {
                          (dateMobile?.start_year === dateMobile?.end_year && dateMobile?.is_present !== 1) ?
                          <>{dateMobile?.start_year}</>
                          :
                          <>
                          {dateMobile?.start_year}
                            {(dateMobile?.end_year ||
                              dateMobile?.is_present === 1) && (
                              <span>
                                —{" "}
                                {dateMobile?.is_present
                                  ? t("Present")
                                  : dateMobile?.end_year}
                              </span>
                            )}
                          </>
                        }
                      </>
                    )}
                  </> 
                  {isAdultContent && (
                    <span className="text-red flex flex-row items-center font-medium  whitespace-nowrap text-4xs 2sm:text-sm 3md:text-base">
                      <BsExclamationDiamondFill className="mr-[2px] " /> {t("adultContent")}
                   </span>
                  )}
                </p>
                

                  <div className="inline-flex flex-wrap gap-2">
                      {
                        categories.map((item,index)=>{
                          return(
                              <p key={index} 
                              style={{ 
                                ...(isAdultContent && {
                                  marginLeft: 0
                                })
                              }}
                              className="px-1.4 py-[2px] 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-3xs 2sm:text-xs uppercase font-semibold rounded-md">
                                {item[currentLang()] || item.name}
                              </p>
                          )
                        })
                      }
                    </div> 
                  {/* <p className="px-1.4 py-[2px] 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-3xs 2sm:text-xs uppercase font-semibold rounded-md">
                    {category}
                  </p> */}
              </div>
            </div>
            {/* <button className="bg-thBg w-10 h-10 rounded-md hidden 4sm:block">
              <FaEllipsisH className="m-auto" />
            </button> */}
            <Popup
              ref={optionRef}
              position="bottom right"
              open={showMoreOption}
              onClose={() => setShowMoreOption(false)}
              arrow={false}
              contentStyle={{ marginTop: 10, marginLeft: 5 }}
              trigger={
                <button
                  className="bg-thBg w-5 h-5 3md:w-10 3md:h-10 rounded-md hidden 1sm:block"
                  onClick={() => setShowMoreOption((open) => !open)}
                >
                  <FaEllipsisH className="m-auto text-4xs 3md:text-base" />
                </button>
              }
            >
              <OptionListItem
                {...{
                  isYourProfile,
                  onEdit,
                  onDelete,
                  //
                  onShare,
                  share,
                  closeModal,
                  onReport,
                  profile,
                  featured,
                  translateMilestone,
                  onCopyLink,
                  onAnalytics,
                  tagView,
                  onRemoveTag,
                }}
                closeMoreOption={() => {
                    setShowMoreOption(false);
                    optionRef.current.close();
                  }}
              />
            </Popup>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function ListViewMilestones({
  isYourProfile,
  showFeatured,
  featured = {},
  profile = {},
  current = [],
  past = [],
  upcoming = [],
  pin = [],
  onWatchMedia = () => {},
  onViewImage = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onShare = () => {},
  onReport = () => {},
  handleViewPdf = () => {},
  milestone_owner,
  translateMilestone= () =>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  onAnalytics = () => {},
}) {
  const {t} = useTranslation();
  const pinnedOrder =useDialogHook(PinnedReorder)
  const { organizeBy } = useMilestones();
  const featuredDate = formatDate(featured, profile?.dateFormat,t);
  const modalView = useDialogHook(ViewMilestoneDialog);

  /**
   * This method will handle viewing of milestone
   * setting dialog state
   */
  const onView = (milestone, event) => {
    modalView(
      {
        profile: profile,
        isYourProfile: isYourProfile,
        data: milestone,
        onWatchMedia: onWatchMedia,
        onViewImage: onViewImage,
        onEdit: onEdit,
        onDelete: onDelete,
        onReport: onReport,
        handleViewPdf: handleViewPdf,
        event:event,
        onShare: () => {
          onShare(milestone, event);
        },
        onCopyLink: () => {
          onCopyLink(milestone);
        },
        onAnalytics: () => {
          onAnalytics(milestone);
        },
        share: true,
      },
      (cb) => {}
    );
  };

  const featuredThumbnail = useMemo(() => {
    if (featured.thumbnail) {
      return featured.thumbnail.webp_url || featured.thumbnail.url;
    }
    return null;
  }, [featured.thumbnail]);

  const customHandle = ()=>{ 
    pinnedOrder({milestones:pin,profile},(callback)=>{
      if(callback?.success){
        return;
      }
    })
  }

  return (
    <div className="w-full container-max-width px-4 3md:px-0">
      {/* listview */}
      {showFeatured && (
        <div className="w-full">
          {/* <p className="px-7.5 3md:px-0 text-lightBlack font-bold text-2xl leading-7.5 tracking-tighter">
            Featured
          </p> */}
          {!_.isEmpty(featured) && (
            <ListViewCard
              dataId={featured.id}
              profile={profile}
              featured={featured}
              url={featuredThumbnail}
              viewUrl={featured.thumbnail.url}
              title={featured.title}
              tag={featured.tag}
              date={featuredDate}
              dateNote={featured.date_note}
              privacy={featured.privacy}
              people={featured.people}
              positions={featured.positions}
              platform={featured.platform}
              location={featured.location}
              description={featured.description}
              isAdultContent={featured.is_adult_content ? true : false}
              // category={featured.category && featured.category.name}
              categories={featured.categories}
              onView={() => onView(featured, "featured")}
              onEdit={() => onEdit(featured, "featured")}
              onDelete={() => onDelete(featured)}
              isYourProfile={isYourProfile}
              onShare={() => onShare(featured, "featured")}
              share={true}
              onReport={() => {
                onReport({...featured, profile:milestone_owner});
              }}
              mention_names={featured.mention_names}
              translateMilestone = {translateMilestone}
              onCopyLink={() => onCopyLink(featured)}
              onAnalytics={() => onAnalytics(featured)}
            />
          )}
        </div>
      )}

      <div className="w-full mt-4.5 3md:mt-10">
        <Collapsible
          hidden={pin.length === 0}
          title={() => (
            <>
              {pin.length > 0 && (
                <div className="flex gap-4 items-center">
                  <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter flex gap-3">
                    <>{t('pinned')}</>
                    <AiFillPushpin className="text-2xl" />
                  </p>
                  {
                    isYourProfile && (
                      <Button
                        icon={<CgArrowsExchangeV className="text-sm"/>}
                        buttonName={t("reorderPinned")}
                        buttonRadius="6px"
                        iconPosition="left"
                        buttonClass="py-2 px-4 bg-gray"
                        buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
                        onClick={() => customHandle()}
                        />
                    )
                  }
                  
                </div>
              )}
            </>
          )}
          content={() => (
            <>
              {pin.map((obj, index) => {
                const date = formatDate(obj, profile?.dateFormat,t);
                const dateMobile = {
                  start_year: obj?.start_year || null,
                  end_year: obj?.end_year || null,
                  is_present: obj?.is_present,
                };
                const thumbnail = obj.thumbnail
                  ? obj.thumbnail.webp_url || obj.thumbnail.url
                  : null;
                return (
                  <ListViewCard
                    dataId={obj.id}
                    dateMobile={dateMobile}
                    profile={profile}
                    featured={obj}
                    key={`past-${index}-${obj.id}`}
                    details={obj}
                    url={thumbnail}
                    viewUrl={obj?.thumbnail?.url || null}
                    title={obj.title}
                    tag={obj.tag}
                    date={date}
                    dateNote={obj.date_note}
                    privacy={obj.privacy}
                    people={obj.people}
                    positions={obj.positions}
                    positionDescription={obj.mp_description}
                    platform={obj.platform}
                    location={obj.location}
                    description={obj.description}
                    isAdultContent={obj.is_adult_content ? true : false}
                    // category={obj.category.name}
                    onView={() => onView(obj, "pin")}
                    onEdit={() => onEdit(obj, "pin")}
                    onDelete={() => onDelete(obj)}
                    isYourProfile={isYourProfile}
                    onShare={() => onShare(obj, "pin")}
                    share={true}
                    onReport={() => onReport({...obj, profile:milestone_owner})}
                    mention_names={obj.mention_names}
                    categories={obj.categories}
                    translateMilestone = {translateMilestone}
                    onCopyLink={() => onCopyLink(obj)}
                    onAnalytics={() => onAnalytics(obj)}
                  />
                );
              })}
            </>
          )}
        />
      </div>
      <div className="w-full mt-4.5 3md:mt-10">
        <Collapsible
          hidden={upcoming.length === 0}
          title={() => (
            <>
              {upcoming.length > 0 && (
                <p className="text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                  {organizeBy === DATE_NEWEST_TO_OLDEST
                    ? DATE_NEWEST_TO_OLDEST
                    : organizeBy === DATE_OLDEST_TO_NEWEST
                    ? DATE_OLDEST_TO_NEWEST
                    : t('upcoming')}
                </p>
              )}
            </>
          )}
          content={() => (
            <>
              {upcoming.map((obj, index) => {
                const date = formatDate(obj, profile?.dateFormat,t);
                const dateMobile = {
                  start_year: obj?.start_year || null,
                  end_year: obj?.end_year || null,
                  is_present: obj?.is_present,
                };
                const thumbnail = obj.thumbnail
                  ? obj.thumbnail.webp_url || obj.thumbnail.url
                  : null;
                return (
                  <ListViewCard
                    dataId={obj.id}
                    dateMobile={dateMobile}
                    profile={profile}
                    featured={obj}
                    key={`upcoming-${index}-${obj.id}`}
                    details={obj}
                    url={thumbnail}
                    viewUrl={obj?.thumbnail?.url || null}
                    title={obj.title}
                    tag={obj.tag}
                    date={date}
                    dateNote={obj.date_note}
                    privacy={obj.privacy}
                    people={obj.people}
                    positions={obj.positions}
                    platform={obj.platform}
                    location={obj.location}
                    description={obj.description}
                    isAdultContent={obj.is_adult_content ? true : false}
                    category={obj.category.name}
                    onView={() => onView(obj, "upcoming")}
                    onEdit={() => onEdit(obj, "upcoming")}
                    onDelete={() => onDelete(obj)}
                    isYourProfile={isYourProfile}
                    onShare={() => onShare(obj, "upcoming")}
                    share={true}
                    onReport={() => onReport({...obj, profile:milestone_owner})}
                    mention_names={obj.mention_names}
                    categories={obj.categories}
                    translateMilestone = {translateMilestone}
                    onCopyLink={() => onCopyLink(obj)}
                    onAnalytics={() => onAnalytics(obj)}
                  />
                );
              })}
            </>
          )}
        />
      </div>
      <div className="w-full mt-4.5 3md:mt-10">
        <Collapsible
          hidden={current.length === 0}
          title={() => (
            <>
              {current.length > 0 && (
                <p className="text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                  {organizeBy === DATE_NEWEST_TO_OLDEST
                    ? DATE_NEWEST_TO_OLDEST
                    : organizeBy === DATE_OLDEST_TO_NEWEST
                    ? DATE_OLDEST_TO_NEWEST
                    : t('current')}
                </p>
              )}
            </>
          )}
          content={() => (
            <>
              {current.map((obj, index) => {
                const date = formatDate(obj, profile?.dateFormat,t);
                const dateMobile = {
                  start_year: obj?.start_year || null,
                  end_year: obj?.end_year || null,
                  is_present: obj?.is_present,
                };
                const thumbnail = obj.thumbnail
                  ? obj.thumbnail.webp_url || obj.thumbnail.url
                  : null;
                return (
                  <ListViewCard
                    dataId={obj.id}
                    dateMobile={dateMobile}
                    profile={profile}
                    featured={obj}
                    key={`current-${index}-${obj.id}`}
                    details={obj}
                    url={thumbnail}
                    viewUrl={obj?.thumbnail?.url || null}
                    title={obj.title}
                    tag={obj.tag}
                    date={date}
                    dateNote={obj.date_note}
                    privacy={obj.privacy}
                    people={obj.people}
                    positions={obj.positions}
                    platform={obj.platform}
                    location={obj.location}
                    description={obj.description}
                    isAdultContent={obj.is_adult_content ? true : false}
                    // category={obj.category.name}
                    onView={() => onView(obj, "current")}
                    onEdit={() => onEdit(obj, "current")}
                    onDelete={() => onDelete(obj)}
                    isYourProfile={isYourProfile}
                    onShare={() => onShare(obj, "current")}
                    share={true}
                    onReport={() => onReport({...obj, profile:milestone_owner})}
                    mention_names={obj.mention_names}
                    categories={obj.categories}
                    translateMilestone = {translateMilestone}
                    onCopyLink={() => onCopyLink(obj)}
                    onAnalytics={() => onAnalytics(obj)}
                  />
                );
              })}
            </>
          )}
        />
      </div>
      <div className="w-full mt-4.5 3md:mt-10">
        <Collapsible
          hidden={past.length === 0}
          title={() => (
            <>
              {past.length > 0 && (
                <p className="text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                  {organizeBy === DATE_NEWEST_TO_OLDEST ||
                  organizeBy === DATE_OLDEST_TO_NEWEST
                    ? ""
                    : t('previous')}
                </p>
              )}
            </>
          )}
          content={() => (
            <>
              {past.map((obj, index) => {
                const date = formatDate(obj, profile?.dateFormat,t);
                const dateMobile = {
                  start_year: obj?.start_year || null,
                  end_year: obj?.end_year || null,
                  is_present: obj?.is_present,
                };
                const thumbnail = obj.thumbnail
                  ? obj.thumbnail.webp_url || obj.thumbnail.url
                  : null;
                return (
                  <ListViewCard
                    dataId={obj.id}
                    dateMobile={dateMobile}
                    profile={profile}
                    featured={obj}
                    key={`past-${index}-${obj.id}`}
                    details={obj}
                    url={thumbnail}
                    viewUrl={obj?.thumbnail?.url || null}
                    title={obj.title}
                    tag={obj.tag}
                    date={date}
                    dateNote={obj.date_note}
                    privacy={obj.privacy}
                    people={obj.people}
                    positions={obj.positions}
                    positionDescription={obj.mp_description}
                    platform={obj.platform}
                    location={obj.location}
                    description={obj.description}
                    isAdultContent={obj.is_adult_content ? true : false}
                    // category={obj.category.name}
                    onView={() => onView(obj, "past")}
                    onEdit={() => onEdit(obj, "past")}
                    onDelete={() => onDelete(obj)}
                    isYourProfile={isYourProfile}
                    onShare={() => onShare(obj, "past")}
                    share={true}
                    onReport={() => onReport({...obj, profile:milestone_owner})}
                    mention_names={obj.mention_names}
                    categories={obj.categories}
                    translateMilestone = {translateMilestone}
                    onCopyLink={() => onCopyLink(obj)}
                    onAnalytics={() => onAnalytics(obj)}
                  />
                );
              })}
            </>
          )}
        />
      </div>
    </div>
  );
}

export { ListViewCard };
